/*
    Modulo CardHeader
*/
import React from 'react';
import css from './card.module.less';
import {ClassName} from 'mgToolsKit';
import PropTypes from 'prop-types';

export default class CardHeader extends React.Component{

   constructor(props){
        super(props);
    }
    
    renderAvatar(){
        const  {avatar} = this.props;
        if(avatar != ""){
            return (
                <div className={css["mg-card-header-avatar"]}>
                   {avatar}
                </div>
            )
        }
        else{
            return (null);
        }

    }

    renderSubTitle(){
        const  {subtitle} = this.props;
        if(subtitle != ""){
            return (
                <span className={css["mg-card-header-subtitle"]}>
                    {subtitle}
                </span>
            )
        }
        else{
            return (null);
        }
    }
    
    render(){
        var  {theme} = this.context;
        var  arrayClassName = [css["mg-card-header"]];
        const  {className, title, subtitle} = this.props;
        
        if(className != undefined){
            arrayClassName.push(className);
        }
        var _className = ClassName(arrayClassName);

        var styles = {
            backgroundColor: theme.backgroundColorTheme,
            borderColor: theme.backgroundColorTheme2
            
        }
        
        var stylesTitle = {
            color: theme.color
        }

         var stylesStatus = {
            color: theme.color
        }
        return(
            <div style={styles} className={_className} onClick={this.context._onExpandChange}>
                {this.renderAvatar()}
                <div className={css["mg-card-header-title-container"]}>
                    <span style={stylesTitle} className={css["mg-card-header-title"]}>
                        {title}
                    </span>
                    {this.renderSubTitle()}
                    
                </div>
                <span style={stylesStatus} className={css["mg-card-header-status"]}></span>
            </div>

        )
    }
}

CardHeader.displayName = "CardHeaderUi";

// PropTypes validation
CardHeader.propTypes = {
    avatar: PropTypes.any,
    title: PropTypes.any.isRequired,
    subtitle: PropTypes.any,
    className: PropTypes.string,
    style: PropTypes.any
};

// default props
CardHeader.defaultProps = {
     avatar: "",
     subtitle: ""
};

CardHeader.contextTypes = {
    _onExpandChange: PropTypes.func,
    theme: PropTypes.object
}